import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPoliceRotatingLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "police-rotating-light" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,18.75H5.25a3,3,0,0,0-3,3,1.5,1.5,0,0,0,1.5,1.5h16.5a1.5,1.5,0,0,0,1.5-1.5A3,3,0,0,0,18.75,18.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.565,5.25H9.435A3,3,0,0,0,6.453,7.919L5.25,18.75h13.5l-1.2-10.831A3,3,0,0,0,14.565,5.25Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 13.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 15.75,
			x2: 12,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 2.25,
			x2: 12,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 9.75,
			x2: .75,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 2.25,
			x2: 3.75,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21.75,
			y1: 9.75,
			x2: 23.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21.75,
			y1: 2.25,
			x2: 20.25,
			y2: 3.75
		})
	]
});
export default SvgPoliceRotatingLight;
